import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../../constants';

/**
 * useCourseSegments
 * Fetches segments for a given course_id from /api/courses/:course_id/segments
 * Returns structured data ready for rendering.
 */
const useCourseSegments = (courseId) => {
    const [segments, setSegments] = useState(null);
    const [meta, setMeta] = useState(null);  // { meters, terrain, course, direction }
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!courseId) return;

        const fetchSegments = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch(`${API_BASE_URL}/api/courses/${courseId}/segments`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch course segments (${response.status})`);
                }
                const data = await response.json();
                setSegments(data.segments);
                setMeta({
                    course_id: data.course_id,
                    meters: data.meters,
                    terrain: data.terrain,
                    course: data.course,
                    direction: data.direction,
                });
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSegments();
    }, [courseId]);

    return { segments, meta, loading, error };
};

export default useCourseSegments;
